import React from 'react';
import './AboutUs.css';

// function AboutUs() {
//   return (
//     <div id='AboutUs' className="AboutUs-body">
//       <h1 class='AboutUs'>About Us</h1>
//       <div>
//         <p style={{ whiteSpace: 'normal' }}>Welcome to VideoArena! VideoArena is a free service allowing users to access, compare, and rank text-to-video capabilities of state-of-the-art generative models. Voting provides valuable data for both consumers selecting models and improving underlying models. Join our efforts!</p>
//       </div>
//       <h2 class='AboutUs'>Our Team</h2>
//       <div >
//         <p style={{ whiteSpace: 'normal' }}>Open-source Contributors: Agenti.ca Team</p>
//       </div>

//       <h2 class='AboutUs'>Partnerships and Sponsors</h2>
//       <div>
//         <p style={{ whiteSpace: 'normal' }}>VideoArena is done in partnership with ChatbotArena who share our goal of advancing intelligence with rigorious neutral-party evaluation. Our work would not be possible with the generous support UC Berkeley, Carnegie Mellon University, and participation from model providers.</p>
//       </div>
//     </div>
//   );
// }


function AboutUs() {
  return (
    <div className="about-us">
      <h1>About Us</h1>
      <div className="introduction">
        <p>Welcome to VideoArena! VideoArena is a free service allowing users to access, compare, and rank text-to-video capabilities of state-of-the-art generative models. Voting provides valuable data for both consumers selecting models and improving underlying models. Join our efforts!</p>
      </div>
      <div className="person-group">
        <h2>Graduate Students</h2>
        <div className="person-container">
          <div className="person">
            <a href="https://michaelzhiluo.github.io/" target="_blank" rel="noopener noreferrer">
              <img src="assets/Michael.jpg" alt="Michael" />
            </a>
            <p><strong>Michael</strong></p>
            <p className="title">UC Berkeley</p>
          </div>
          <div className="person">
            <a href="https://people.eecs.berkeley.edu/~wong.justin/" target="_blank" rel="noopener noreferrer">
              <img src="assets\Justin.jpeg" alt="Justin" />
            </a>
            <p><strong>Justin</strong></p>
            <p className="title">UC Berkeley</p>
          </div>
          <div className="person">
            <a href="https://btrabuc.co/" target="_blank" rel="noopener noreferrer">
              <img src="assets\Brandon.png" alt="Brandon" />
            </a>
            <p><strong>Brandon</strong></p>
            <p className="title">Carnegie Mellon University</p>
          </div>
        </div>
      </div>
      <div className="person-group">
        <h2>Undergraduate Students</h2>
        <div className="person-container">
          <div className="person">
            <img src="assets\brandonHuang.jpg" alt="Brandon Huang" />
            <p><strong>Brandon Huang</strong></p>
            <p className="title">UC Berkeley</p>
          </div>
          <div className="person">
            <a href="https://cck0517.github.io/personal_website/" target="_blank" rel="noopener noreferrer">
              <img src="assets\alex cao.jpg" alt="Chengkun Cao" />
            </a> 
            <p><strong>Chengkun Cao</strong></p>
            <p className="title">UC Berkeley</p>
          </div>
          <div className="person">
            <a href="https://mich889.github.io/" target="_blank" rel="noopener noreferrer">
              <img src="assets\michelle.JPEG" alt="Michelle" />
            </a> 
            <p><strong>Michelle</strong></p>
            <p className="title">UC Berkeley</p>
          </div>
        </div>
      </div>
      <div className="person-group">
        <h2>External Contributors</h2>
        <div className="person-container">
          <div className="person">
            <img src="assets\Jeffrey.jpeg" alt="Jeffrey Luo" />
            <p><strong>Jeffrey Luo</strong></p>
            <p className="title"></p>
          </div>
          <div className="person">
            <img src="assets\Garrett.png" alt="Garrett Cai" />
            <p><strong>Garrett Cai</strong></p>
            <p className="title"></p>
          </div>
          <div className="person">
            <img src="assets\people_placeholder.png" alt="Ruofei Yang" />
            <p><strong>Ruofei Yang</strong></p>
            <p className="title"></p>
          </div>
        </div>
      </div>
      <div className="person-group">
        <h2>Advisors</h2>
        <div className="person-container">
          <div className="person">
            <a href="https://people.eecs.berkeley.edu/~istoica/" target="_blank" rel="noopener noreferrer">
              <img src="assets\ion_picture_small.jpg" alt="Ion Stoica" />
            </a> 
            <p><strong>Ion Stoica</strong></p>
            <p className="title">UC Berkeley</p>
          </div>
          <div className="person">
            <a href="https://people.eecs.berkeley.edu/~jegonzal/" target="_blank" rel="noopener noreferrer">
              <img src="assets\JoeyGonzalez.jpg" alt="Joey Gonzalez" />
            </a> 
            <p><strong>Joseph E. Gonzalez</strong></p>
            <p className="title">UC Berkeley</p>
          </div>
          <div className="person">
            <a href="https://www.cs.cmu.edu/~rsalakhu/" target="_blank" rel="noopener noreferrer">
              <img src="assets\russ.jpg" alt="Russ Salkutinaov" />
            </a> 
            <p><strong>Ruslan Salakhutdinov</strong></p>
            <p className="title">Carnegie Mellon University</p>
          </div>
        </div>
      </div>
      <div className="partners">
        <h2>Partners and Sponsors</h2>
        <div className="introduction">
          <p>VideoArena is done in partnership with ChatbotArena who share our goal of advancing intelligence with rigorious neutral-party evaluation. Our work would not be possible with the generous support UC Berkeley, Carnegie Mellon University, and participation from model providers.
          </p>
        </div>
        <div className="logo-container">
          <div className="logo">
            <img src="assets\UCB.png" alt="ucb" />
          </div>
          <div className="logo">
            <img src="assets\CMU.png" alt="cmu" />
          </div>
          <div className="logo">
            <img src="assets\sky lab.png" alt="sky lab" />
          </div>
          <div className="logo">
            <img src="assets\chatbot arena.png" alt="chatbot arena" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;